export default "__VITE_ASSET__DVS0h9up__"